import axios from 'axios'
axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')

const state = {
  status: '',
  receipts: []
}

const mutations = {
  REQUEST (state) {
    state.status = 'loading'
  },
  SUCCESS (state) {
    state.status = 'success'
  },
  ERROR (state, error) {
    state.status = 'error'
  },
  SET_RECEIPTS (state, receipts) {
    state.receipts = receipts
  }
}

const actions = {
  clientAddReceiptItem ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/client/receipt/addItem`, payload)
        .then(response => {
          commit('SUCCESS')
          const { final, receiptId } = response.data
          resolve({ final, receiptId })
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  addReceiptItem ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/admin/receipt/addItem`, payload)
        .then(response => {
          commit('SUCCESS')
          resolve(response.data.final)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  async cancelReceipt ({ commit }, payload) {
    commit('REQUEST')
    try {
      const response = await axios.get(`${process.env.VUE_APP_SERVER_HOST}/api/common/receipt/${payload.receiptId}/delete`)
      commit('SUCCESS')
      return response
    } catch (error) {
      commit('ERROR', error)
      throw error
    }
  },
  async validateNewReceipt ({ commit }, payload) {
    commit('REQUEST')
    try {
      const response = await axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/client/receipt/validateNewReceipt`, payload)
      commit('SUCCESS')
      return response
    } catch (error) {
      commit('ERROR', error)
      throw error
    }
  },
  updateReceiptItem ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/admin/receipt/${payload.receiptId}/receiptItem/${payload.itemId}`, { updatedFields: payload.updatedFields })
        .then(response => {
          commit('SUCCESS')
          resolve(response.data.receipt)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  finishReceipt ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/client/receipt/${payload.receiptNumber}/finish`)
        .then(response => {
          commit('SUCCESS')
          resolve(response.data.receipt)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  approveReceipt ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/admin/receipt/${payload.receiptId}/approve`, payload.body)
        .then(response => {
          commit('SUCCESS')
          resolve(response.data.receipt)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  denyReceipt ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.post(`${process.env.VUE_APP_SERVER_HOST}/api/admin/receipt/${payload.receiptId}/deny`)
        .then(response => {
          commit('SUCCESS')
          resolve(response.data.receipt)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  },
  getAllReceipts ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('REQUEST')
      axios.get(`${process.env.VUE_APP_SERVER_HOST}/api/admin/receipt/list`)
        .then(response => {
          commit('SUCCESS')
          commit('SET_RECEIPTS', response.data.receipts)
          resolve(response.data.receipts)
        })
        .catch(err => {
          commit('ERROR', err)
          reject(err)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
